import React from 'react';
import { Typography, Row, Col, Space, Empty, Input, Card, Divider } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { CategoryCard, CategoryChildren } from '../../card/CategoryCard/CategoryCard';

const { Text } = Typography;

const CategoryList = ({
  selectedType,
  categories,
  selectedCategories,
  expandedCategories,
  searchTerm,
  onSearchChange,
  onCategoryToggle,
  onChildToggle,
  onToggleExpansion,
  color,
  title = "Categorias Disponíveis",
  disabledCategories = {},
  checkedCategories = {} // NOVO
}) => {
  // Função recursiva para calcular se uma categoria tem filhos selecionados
  const hasSelectedChildren = (category) => {
    if (!category.children || category.children.length === 0) return { total: 0, selected: 0 };
    
    let total = 0;
    let selected = 0;
    
    const countChildren = (children) => {
      children.forEach(child => {
        total++;
        const childId = child.codCategoria || child.id;
        if (selectedCategories[childId] || checkedCategories[childId]) {
          selected++;
        }
        if (child.children && child.children.length > 0) {
          countChildren(child.children);
        }
      });
    };
    
    countChildren(category.children);
    return { total, selected };
  };

  return (
    <Card
      title={<span style={{ fontSize: 16, fontWeight: 600 }}>{title}</span>}
      style={{ marginBottom: 24 }}
    >
      <div style={{ marginBottom: 20 }}>
        <Input
          placeholder="Buscar categorias..."
          prefix={<SettingOutlined />}
          value={searchTerm}
          onChange={onSearchChange}
          style={{ maxWidth: 400 }}
        />
      </div>

      {(selectedType === null || selectedType === undefined) ? (
        <div style={{
          textAlign: 'center',
          padding: '40px 20px',
          color: '#8c8c8c'
        }}>
          <Text style={{ fontSize: 16 }}>
            Selecione um tipo de classificação para visualizar as categorias
          </Text>
        </div>
      ) : categories.length > 0 ? (
        <Space direction="vertical" style={{ width: '100%' }}>
          {categories.map(category => {
            const categoryId = category.codCategoria || category.id;
            
            // Calcula filhos selecionados recursivamente
            const { total: totalFilhos, selected: filhosSelecionados } = hasSelectedChildren(category);
            
            // Determina se está selecionado
            const isChecked = !!selectedCategories[categoryId] || !!checkedCategories[categoryId];
            const isIndeterminate = !isChecked && filhosSelecionados > 0 && filhosSelecionados < totalFilhos;
            // Se há ao menos uma subcategoria selecionada para o grupo em configuração, a categoria raiz fica ativa
            const isDisabled = filhosSelecionados > 0 ? false : !!disabledCategories[categoryId];

            return (
              <React.Fragment key={categoryId}>
                <CategoryCard
                  category={category}
                  isSelected={isChecked}
                  isIndeterminate={isIndeterminate}
                  isExpanded={!!expandedCategories[categoryId]}
                  onToggleSelection={onCategoryToggle}
                  onToggleExpansion={onToggleExpansion}
                  color={color}
                  disabled={isDisabled}
                >
                  {category.children && expandedCategories[categoryId] && (
                    <CategoryChildren
                      children={category.children}
                      selectedCategories={selectedCategories}
                      checkedCategories={checkedCategories}
                      onToggleSelection={onChildToggle}
                      onToggleExpansion={onToggleExpansion}
                      expandedCategories={expandedCategories}
                      color={color}
                      disabledCategories={disabledCategories}
                      level={1}
                    />
                  )}
                </CategoryCard>
                <Divider />
              </React.Fragment>
            );
          })}
        </Space>
      ) : (
        <Empty
          description="Nenhuma categoria encontrada"
          style={{ margin: '48px 0' }}
        />
      )}
    </Card>
  );
};

export default CategoryList; 